function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var google = {
  "id": "google",
  "symbol": "<symbol id=\"google\" viewBox=\"0 0 28 28\" style=\"fill: currentColor\"><path d=\"M14 0C6.26875 0 0 6.26875 0 14C0 21.7313 6.26875 28 14 28C21.7313 28 28 21.7313 28 14C28 6.26875 21.7313 0 14 0ZM19.2188 19.8C17.95 20.9688 16.2188 21.6562 14.1531 21.6562C11.1625 21.6562 8.575 19.9406 7.31563 17.4406C6.79688 16.4062 6.5 15.2375 6.5 14C6.5 12.7625 6.79688 11.5938 7.31563 10.5594C8.575 8.05625 11.1625 6.34062 14.1531 6.34062C16.2156 6.34062 17.9469 7.1 19.275 8.33438L17.0812 10.5312C16.2875 9.77188 15.2781 9.3875 14.1562 9.3875C12.1625 9.3875 10.475 10.7344 9.87187 12.5437C9.71875 13.0031 9.63125 13.4937 9.63125 14C9.63125 14.5063 9.71875 14.9969 9.87187 15.4562C10.475 17.2656 12.1625 18.6125 14.1531 18.6125C15.1844 18.6125 16.0594 18.3406 16.7437 17.8813C17.5562 17.3375 18.0938 16.5281 18.2719 15.5688H14.1531V12.6062H21.3625C21.4531 13.1094 21.5 13.6313 21.5 14.1719C21.5 16.5063 20.6656 18.4656 19.2188 19.8Z\" /></symbol>"
};

export { google };
